import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Api from '../../lib/seam-api';

import moment from 'moment';

const NoResults = ({ value = '' }) => {
    return (
        <div className="w-full h-[400px] flex justify-center items-center">
            <div className="flex flex-col gap-[10px] items-center justify-center">
                <img src="/assets/index/no-results.svg" className="h-[150px] mb-4" aria-label="No Results Image"/>
                <h2 class="leading-tight text-2xl font-extrabold text-gray-900 dark:text-white">No results found</h2>
                <p class="mb-4 font-normal text-base text-gray-500 dark:text-gray-400">We couldnt find any matches for <b>{ value }</b></p>
            </div>
        </div>
    )
}

class GeneralIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search : '',
            items : [],
            page: 1,
            pageCount : 0,
            cdnUrl : '/images',
            direction : 'desc',
            order: 'published',
            loading: false,
        };

        this.searchCanceler = null;
    }

    onChangeHandler({target: { value }}) {
        this.setState({
            search : value
        }, () => this.changed());
    }

    componentDidMount() {
        const queryParameters = new URLSearchParams(window.location.search);
        const term = queryParameters.get('term');

        if (term && term.length > 0) {
            return this.setState({ search: term }, () => this.changed());
        }

        this.changed();
    }

    changed() {
        if(this.state.search.length >= 1) {
            return this.search();
        }

        this.fetchItems();
    }

    search() {
        this.setState({ loading: true })

        if(this.searchTimeOut) {
            clearTimeout(this.searchTimeOut);

        }
        if(this.searchCanceler !== null) {
            this.searchCanceler.cancel('Cancel Content Search');
            this.searchCanceler = null;
        }

        this.searchTimeOut = setTimeout(() => {
            const contentTypes = []

            if (this.props.contentTypeId !== null) contentTypes.push(this.props.contentTypeId);

            Api.content().search(this.state.search, contentTypes, [], searchCanceler => {
                this.searchCanceler = searchCanceler;
            }, this.state.direction).then(response => {
                this.setState({
                    items : response.data,
                    pageCount : 0,
                    page : 1,
                    cdnUrl : response.meta.cdn_url,
                    loading: false,
                })
            });
        }, 200);

    }

    fetchItems(page = this.state.page) {
        this.setState({ loading: true })

        let contentTypes = []

        if (this.props.contentTypeId !== null) {
            if (this.props.contentTypeId.includes(',')) {
                const ids = this.props.contentTypeId.split(',');

                contentTypes = ids;
            } else {
                contentTypes.push(this.props.contentTypeId);
            }
        }

        Api.content().list(page, 1000, contentTypes, [], this.state.order, this.state.direction).then(response => {
            this.setState({
                items : response.data,
                pageCount : response.meta.last_page,
                cdnUrl : response.meta.cdn_url,
                loading: false,
            });
        })
    }

    handlePageClick(event) {
        this.setState({ page: event.selected + 1 }, () => this.fetchItems());

    }

    truncateDescription (input) {

        return input?.length > 65 ? `${input.substring(0, 65)}...` : input;

    }

    getSlug(slug, item) {
        let returnedSlug = slug;

        if (item.content_type_id === 19) {
            const link = slug.split('/');

            link.shift();

            returnedSlug = 'service/grants/' + link.join('');
        }

        if (item.content_type_id === 14) {
            returnedSlug = 'grants';
        }

        if (item.content_type_id === 22) {
            const link = slug.split('/');

            link.shift();

            returnedSlug = 'service/elearning/' + link.join('');
        }

        if (item.content_type_id === 24) {
            returnedSlug = 'programmes';
        }

        if (item.content_type_id === 12) {
            const split = slug.split('/');

            if (split.length === 1) {
                returnedSlug = slug;
            } else {
                returnedSlug = split[1];
            }
        }

        if (item.content_type_id === 21) {
            returnedSlug = 'news';
        }

        if (item.content_type_id === 26) {
            returnedSlug = 'events';
        }

        if (item.content_type_id === 6) {
            returnedSlug = 'our-team';
        } 

        if (item.content_type_id === 9) {
            if (slug.split('/').length === 1) {
                returnedSlug = slug;
            }
        }

        return returnedSlug;
    }

    onDirection(event) {
        this.setState({ direction: event.target.value }, () => {
            this.changed();
        })
    }

    onOrder(event) {
        this.setState({ order: event.target.value }, () => {
            this.changed();
        })
    }

    renderFilters() {
        return (
            <div className="flex flex-row justify-between flex-wrap gap-4">
                <div className="flex flex-row gap-4 flex-wrap">
                    <select onChange={this.onOrder.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value='published' selected>Published (Date)</option>
                            <option value='title'>Title (Alphabetical)</option>
                        </select>

                        <select onChange={this.onDirection.bind(this)} class="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm  focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                            <option value='asc'>Ascending</option>
                            <option value='desc' selected>Descending</option>
                        </select>
                </div>
            </div>
        )
    }

    render () {
        return (
            <div className="flex flex-col gap-16 w-full mx-auto max-w-screen-xl py-8 px-4">
                { this.props?.type !== 'search' && this.state.search?.length === 0 && this.renderFilters() }

                <div className="flex flex-col gap-16">
                        { this.state?.items?.length > 0 ? <div class="bg-white dark:bg-gray-900 gap-16 grid grid-cols-1 md:grid-cols-2"> { this.state?.items?.map((item, index) => {
                            return (
                                <div key={index} class="relative gap-4 flex flex-col">
                                    <a href={`/${this.props.contentTypeSlug ? this.props.contentTypeSlug + '/' : ''}${this.getSlug(item?.slug, item)}`} class="flex-col h-full flex bg-gray-50 hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700">
                                        <div className="object-cover w-full h-80" alt="" style={{
                                            backgroundImage: `url('${this.state.cdnUrl}/images/${item?.meta?.preview_image}')`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center'
                                        }}></div>
                                        <div class="h-[calc(100%_-_20rem)] flex flex-col justify-between p-8 leading-normal">
                                            <div className="flex flex-col">
                                                <h2 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{ item?.title }</h2>
                                            
                                                <p class="mb-3 font-normal text-gray-700 dark:text-gray-400">{ moment(item?.published)?.format('LLLL') }</p>

                                                { item?.tags?.length > 0 && <div className="absolute top-8 left-8 z-10 mb-3 flex gap-2 flex-wrap">
                                                    { item?.tags?.map(tag => <span className="py-2 px-4 bg-gray-50 shadow-md no-underline rounded-full bg-blue text-black font-sans font-semibold text-sm border-blue btn-primary hover:bg-blue-light focus:outline-none active:shadow-none mr-2">{ tag?.name }</span>) }    
                                                </div>}

                                                { item?.meta?.preview_description && <p class="mt-3 mb-4 font-normal text-base text-gray-500 dark:text-gray-400">{ item?.meta?.preview_description?.substr(0, 200) }</p> } 
                                            </div>
                                        
                                            <a role="link" aria-label={`Read more about ${item?.title}`} href={`/${this.props.contentTypeSlug ? this.props.contentTypeSlug + '/' : ''}${this.getSlug(item?.slug, item)}`} class="w-fit text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium text-sm px-5 py-2.5 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800 text-center">Read More</a>  
                                        </div>
                                    </a>
                                </div>
                            )
                        }) } </div> : !this.state.loading && <NoResults value={this.state.search}/> }
                </div>
            </div>
        )
    }
}

export default GeneralIndex;

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('general-index')

    if (element) {
        ReactDOM.render(<GeneralIndex contentType={element.getAttribute('contentType')} contentTypeId={element.getAttribute('contentTypeId')} contentTypeSlug={element.getAttribute('contentTypeSlug')}/>, element);
    }
});
